'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./miraklHandleIncidents'));

    $('form.contact-seller-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        var isValid = true;
        var $form = $(this);
        $form.find('textarea, select').each((idx, formEl) => {
            var $formEl = $(formEl);
            var value = $.trim($formEl.val());
            if ((!!$formEl.parent().attr('required') && value === '') ||
                ($formEl.data('minlength') && $formEl.data('maxlength') && value.length > 0 && (value.length < $formEl.data('minlength') || value.length > $formEl.data('maxlength')))) {
                $formEl.addClass('is-invalid');
                $formEl.next().removeClass('d-none');
                isValid = false;
            } else {
                $formEl.removeClass('is-invalid');
                $formEl.next().addClass('d-none');
            }
        });
        if (isValid) {
            $.ajax({
                url: $form.attr('action'),
                method: 'POST',
                data: $form.serialize(),
                success: function (data) {
                    if (!data.threadFailed) {
                        $('.contact-seller-page').html(data.successHtml);
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
        $.spinner().stop();
    });
});

function fillModalElement(selectedValueUrl, template, $clonedProd) {
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        data: {
            template: template
        },
        success: function (data) {
            $('#orderHistoryModal .order-history-popup-content').empty();
            $('#orderHistoryModal .order-history-popup-content').html(data);
            $clonedProd.find('.order-status-items').remove();
            $clonedProd.find('.product-name').removeClass('product-name');
            $clonedProd.addClass('border-0 pt-4');
            $('.order-product-image-modal').append($clonedProd);
            $('#orderHistoryModal').modal('show');
            $.spinner().stop();
        }
    });
}
/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    if(newUrl !== null && newUrl !== undefined && newUrl !== ''){
        newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
            return key + '=' + encodeURIComponent(params[key]);
        }).join('&');
        return newUrl;
    }

}


$(document).on('keyup', 'form.contact-seller-form textarea', function (e) {
    var val = e.currentTarget.value
    var len = val.length;
    $('form.contact-seller-form .char-counter span').text(len + ' ');
    $('form.contact-seller-form .char-counter').toggleClass('error', len < 3 || len > 5000);
})

$(document).on('click', '.return-order-popup, .contact-seller-popup', function (e) {
    e.preventDefault();
    $.spinner().start();
    var buttonElement = $(this);
    var clonedProd = buttonElement.parents('.product-summary-inner').clone();
    var selectedValueUrl = buttonElement.attr('href');
    var templateName = buttonElement.data('template');
    fillModalElement(selectedValueUrl, templateName, clonedProd);
});

// onclick event 
$('body').on('click', '.get-reciept-back-link', function (e) {
    e.preventDefault();
    $.spinner().start();
    if($('.user-profile .justify-content-center').length > 0){
        $('.user-profile .justify-content-center').removeClass('d-none');
    }
    if($('.order-reciept-section').length > 0) {
        $('.order-reciept-section').addClass('d-none');
        $('.order-reciept-section').empty();
    }
    $('.account-login-page .order-status-unreg').removeClass('d-none');
    $('.order-details-status-section').removeClass('d-none');
    $.spinner().stop();
});
// onclick to close the get started modal pop up for ios once button is clicked
$('body').on('click', '.get-started-button', function() {
    $('#returnRedirect').modal('hide');
});

// onclick check returnbear event for mirakl  product
$('body').on('click', '.rb-return-button', function (e) {
    e.preventDefault();
    $('body').spinner().start();
    const radius = 15;
    var empty = '';
    var hash = '#';
    var hideAlert = 'd-none';

    //populate the attributes
    var $button = $(this);
    var $incidentDialog = $(hash + $button.data('dialog'));
    var $incidentAlert = $(hash + $button.data('alert'));
    var $incidentSuccess = $(hash + $button.data('success'));
    var errorMsg = $button.data('error');
    var errorLoginMsg = $button.data('errorlogin');
    var modalUrl = $(this).attr('data-url');

    var editProductUrl = $(this).attr('data-open-action');
    var orderPostalCode = $(this).attr('data-postal-code');
    var shopID =$(this).attr('data-shop-id');
    var returnBearURL =  $(this).attr('returnbear-hyperlink');
    var dataDialog = $(this).attr('data-dialog');
    // accessing the categoryId passed from orderDetails.js
    var categoryId = $(this).attr('data-category');
    var requestUrl = '';
    var urlParams = {
        radius: radius
    };
    var isSafari = navigator.userAgent.indexOf('Safari') !=-1 && navigator.userAgent.indexOf('CriOS') == -1 && navigator.userAgent.indexOf('Chrome') == -1;
    var payload = {
        postalCode: orderPostalCode,
        shopId: shopID.toString(),
        categoryId:categoryId.toString()
    }

    if(editProductUrl !== '' && editProductUrl !== undefined){
        requestUrl = appendToUrl(editProductUrl, urlParams);
        $.ajax({
            url: requestUrl,
            type: 'get',
            data: payload,
            dataType: 'json',
            success: function (response) {
                if(response.inRBProgram !== null && response.inRBProgram !== undefined && response.isReturnBearEligible !== null && response.isReturnBearEligible !== undefined){
                    //Populate URL to RB
                    var redirectToRB = returnBearURL + response.isReturnBearEligible;
                    if(response.inRBProgram){
                        if(isSafari)
                        {
                            $('#returnRedirect').modal('show');
                            $('#returnBearRedirectLinkBayModal').attr("href",redirectToRB)
                        }else {
                             //Seller participates in return bear program
                            $('#returnBearRedirectLink').attr("href",redirectToRB);
                            document.getElementById("returnBearRedirectLink").click()
                        }  
                        $('body').spinner().stop();
                    }else{
                        //Seller doesn't participate in RB program
                        $(this).attr('data-toggle', 'modal');
                        $(this).attr('data-target', '#'+dataDialog);
                        /* Open the incident dialog listing the reasons and a textarea field for communication */
                        $.ajax({
                            url: modalUrl,
                            type: 'get',
                            data: {
                                open: $button.data('open')
                            },
                            success: function (data) {
                                $incidentSuccess.addClass(hideAlert).html(empty);
                                if (data && data.success) {
                                    $incidentAlert.addClass(hideAlert).html(empty); // clear out any errors
                                    var options = [];
                                    options.push('<option value="', '', '">', '', '</option>');
                                    $.each(data.message, function (index, value) {
                                        options.push('<option value="', value.code, '">', value.label, '</option>');
                                    });
                                    $incidentDialog.find('.mirakl-reason-select').html(options.join('')); // populate the select box
                                    $incidentDialog.modal('show'); // open the dialog
                                } else if (data && data.message) {
                                    $incidentAlert.removeClass(hideAlert).html(data.message); // show an error
                                } else {
                                    $incidentAlert.removeClass(hideAlert).html(errorLoginMsg); // show an error
                                }
                                $('body').spinner().stop();
                            },
                            error: function () {
                                $incidentSuccess.addClass(hideAlert).html(empty);
                                $incidentAlert.removeClass(hideAlert).html(errorMsg); // show an error
                                $('body').spinner().stop();
                            }
                        });
                    }
                }

            },
            error: function () {
                //Populate URL to RB without response
                $incidentSuccess.addClass(hideAlert).html(empty);
                $incidentAlert.addClass(hideAlert).html(empty); // clear out any errors
                $incidentAlert.removeClass(hideAlert).html(errorMsg); // show an error
                $('body').spinner().stop();
            }
        });
    }
});
// return policy link for the bay items
$('body').on('click', '.returnPolicyLink, .return-policy-button', function (e) {
    var returnWindow = $(this).attr('data-return-window');
    var shopName=$(this).attr('data-shopName');
    var bayIconImg = $(this).attr('data-bay-img-icon');
    var shopLabel=$(this).attr('data-tb-label');
    var storeReturnLabelTxt=$(this).attr('data-store-return-label');
    var soldByLabel= $(this).attr('data-soldby-label');
    var storeReturnLabel=  '<span class="custom-tooltip">'+
    '<button class="tooltip-info rounded-circle" type="button" >'+i+'</button>'+ storeReturnLabelTxt+'</span>'
    var soldBy='<div class="mt-2 mb-2 order-history-product border-bottom-0">'+'<div class="product-modal-order-header order-seller-title d-inline-flex align-items-center">'
        +' <span class="orderdetails-icon-marketplace-image pt-2 pl-3" style="background-image: url('+bayIconImg+')">'+'</span>' 
                                        +'<span class="pl-1">'+soldByLabel+' '+shopName +'</span>' 
                                    +'</div>'+'</div>'
    $('body').trigger('adobe:returnPolicyClick', shopLabel);
    $('.returnPolicyModel .free-store-return-text').empty().append(storeReturnLabel);
    $('.return-policy-heading .shop-name').empty().append(shopLabel);
    $('.returnPolicyModel .shop-flag-and-name').empty().append(soldBy);
    $('.returnPolicyModel .return-message-content').empty().append(returnWindow);
});
// navigating to the view Reciept page
$('body').on('click', '.view-reciept-link, .order-details-left-view-receipt', function (e) {
    e.preventDefault();
    $.spinner().start();
    if ($(this).data('orderno') !== null) {
        var orderNo = $(this).data('orderno');
        var $detailsContainerReciept = $('.order-reciept-section-' + orderNo);
        if($detailsContainerReciept.length >0 && $('.order-reciept-section').length > 0) {
            $('.order-reciept-section').removeClass('d-none');
            $('.order-reciept-section').html($detailsContainerReciept.html());
        }
        if($('.user-profile .justify-content-center').length > 0){
            $('.user-profile .justify-content-center').addClass('d-none');
        }
        $('.account-login-page .order-status-unreg').addClass('d-none');
        $('.order-details-status-section').addClass('d-none');
    }
    $.spinner().stop();
});

$('body').on('click', '.order-detail-link-wrapper', function (e) {
    if ($('.order-cannot-cancel').length > 0){
        $('.order-cannot-cancel').addClass('d-none');
    }
    if ($('.order-cancel-oms-fail').length > 0) {
        $('.order-cancel-oms-fail').addClass('d-none');
    }
    e.preventDefault();
    $.spinner().start();
    if ($(this).data('orderno') !== null)
        var orderNo = $(this).data('orderno');
    if ($('.order-details-section').length > 0){
        var $detailsContainer = $('.order-details-section-' + orderNo);
    }
    if ($(this).find('.order-detail-link') !== null) {
        var $icon = $(this).find('.order-detail-link');
    }
    if ($.trim($detailsContainer.html()).length) {
        $detailsContainer.empty();
        $icon.removeClass('active');
        $icon.removeClass('svg-svg-49-minus-thin');
        $.spinner().stop();
    } else {
        $detailsContainer.empty();
        if($icon.length !== null){
            $icon.addClass('active');
            $icon.addClass('svg-svg-49-minus-thin');
        }
        $.ajax({
            url: $(this).attr('href'),
            method: 'GET',
            data: {
                ajax: true
            },
            success: function (data) {
                if (!data.error) {
                    $detailsContainer.html(data);
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
});

$('body').on('click', '.cancel-contact', function() {
    $.spinner().start();
    $.ajax({
        url: $('.contact-seller-page').data('cancel-url'),
        method: 'GET',
        data: {
            ajax: true
        },
        success: function (data) {
            $('.contact-seller-page').removeClass('col-6');
            $('.contact-seller-page').empty().html(data);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
});